'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function BlogCardSkeleton() {
  return (
    <div
      className={cn('animate-pulse', 'col-span-1 flex w-full flex-col items-start justify-start')}
    >
      <div className="h-[550px] w-full rounded-[16px] bg-neutral-100 sm:h-[400px] md:h-[450px] lg:h-[475px] xl:h-[500px]" />
    </div>
  );
}
